<template>
  <main class="dashboard links">
    <div class="mb-4">
      <h2><b>Проект</b> <span>{{ project?.name }}</span></h2>
      <h3 v-if="!pdf">Ссылки из всех pdf файлов</h3>
      <h6 v-if="pdf"><b>Персона</b> {{ pdf?.person?.name }} ID ({{ pdf?.person?.pf_id }})</h6>
      <h6 v-if="pdf"><b>Источник</b> {{ pdf?.get_source_display }}</h6>
      <h6 v-if="pdf"><b>Ссылка</b> <a :href="pdf?.pdf" target="_blank">pdf</a></h6>

      <BackButton></BackButton>
    </div>


    <div class="screen-list">
      <div class="btn-group" v-if="pdf" role="group" aria-label="Basic outlined example">
        <router-link
            :to="{name: 'pdf_db_detail', params: {id: this.$route.params.id, pdf_id: this.$route.params.pdf_id}}"
            type="button" class="btn btn-outline-dark">Структура
        </router-link>
        <router-link
            :to="{name: 'pdf_db_links', params: {id: this.$route.params.id, pdf_id: this.$route.params.pdf_id}}"
            type="button" class="btn btn-dark">Ссылки
        </router-link>
      </div>


      <div class="table-responsive" style="height: auto">
        <table class="table">
          <thead>
          <tr class="sticky-top">
            <th style="display: flex; gap: 3px; align-items: center;padding: 0 10px;">
              <label for="check_all">№</label></th>
            <th>Ссылка</th>
            <th>Тональность</th>
            <th>Тип ссылки</th>
            <th>Домен</th>
            <th>Запрос</th>
          </tr>
          </thead>
          <tbody>
          <template v-for="(link, index) in links">
            <tr>
              <td style="display: flex; gap: 3px; align-items: center;">
                <label :for="link.link_obj_id ? link.link_obj_id : link.id">{{ index + 1 }}</label>
              </td>
              <td>
                <div class="d-flex link">

                  <div>
                    <a :href="link.link" target="_blank" :style="$func.getClass(link)">{{ link.link }}</a>
                  </div>
                </div>
              </td>
              <td>
                <ul class="dropdown list">
                  <template
                      v-if="project.project_type !== 'archive' && ($store.getters.permission.indexOf('link_edit') + 1)">
                    <template v-for="(tone, key) in tones(link)">
                      <li v-if="!tone.no_filter"
                          v-on:click="link.get_tone_display=tone.name;
                           link.kind_type='manual';
                          link.get_kind_type_display='Ручной';
                          link.type_tone='new';
                          link.get_type_tone_display='Новый';
                          link.tone=key;
                          updateLink(link, ['kind_type', 'type_tone', 'tone']);"
                          :class="`dropdown-item ${(tone.synonym.indexOf(link.tone)+1)?`active bg-${key}`:''}`">
                        {{ tone.name }}
                      </li>
                    </template>
                  </template>
                  <template v-else>
                    <li :class="`dropdown-item active bg-${link.tone}`">
                      {{ link.get_tone_display }}
                    </li>
                  </template>
                </ul>

              </td>
              <td>
                <ul class="dropdown list">
                  <template
                      v-if="project.project_type !== 'archive' && ($store.getters.permission.indexOf('link_edit') + 1)">
                    <li v-for="(tone, key) in  type_tones(link)"
                        v-on:click="updateTypeTone(link, tone, key)"
                        :class="`dropdown-item pb-0 pt-0 ${link.type_tone === key?'active':''}`">{{ tone }}
                    </li>
                  </template>
                  <template v-else>
                    <li class="dropdown-item active">
                      {{ link.get_type_tone_display }}
                    </li>
                  </template>
                </ul>
              </td>
              <td>
                <div class="domain">
                  <div>{{ link.domain }}</div>
                  <a v-if="link.has_contents" href="" class="btn btn-sm btn-outline-secondary"
                     v-on:click.prevent="getContent(link.link_obj_id ? link.link_obj_id : link.id, link)">
                    Контент
                  </a>
                </div>
              </td>

              <td>
                <table class="keys">
                  <tr>
                    <td class="key-name"></td>
                    <td v-for="engine in $ENGINES" class="engine">
                      <i :class="`ico ${engine}`"></i>
                    </td>
                  </tr>
                  <tr class="key" v-for="keyword in link.keyword">
                    <td class="key-name">{{ keyword.name }}</td>
                    <td class="engine">
                      <div class="place" v-for="place in keyword.place.filter(x=>x.engine==='yandex')"> {{
                          place.place
                        }}
                      </div>
                    </td>
                    <td class="engine">
                      <div class="place" v-for="place in keyword.place.filter(x=>x.engine==='google')">
                        {{ place.place }}
                      </div>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
      <modal modal_id="link_content">
      <template v-slot:header v-if="content">
        <div class="blog-post">
          <h2 class="blog-post-title" v-html="content.title"></h2>

          <p class="blog-post-meta">{{ content.date_create }}</p>
        </div>
        <ul style="font-weight: 300; font-size: 11px;">
          <li>
            <b class="text-primary">text</b> - Словоформы имени персоны
          </li>
          <li>
            <span class="bg-warning">text</span> - Запросы
          </li>
          <li>
            <span class="bg-negative">text</span> - Негативные отрезки
          </li>
          <li>
            <span class="bg-danger">text</span> - Негативные фразы
          </li>
        </ul>
      </template>

      <template v-slot:body>
        <div class="card">


          <div class="card-body pb-5" v-if="content">
            <article class="blog-post">


              <p v-html="content.description"></p>
              <hr>
              <div v-html="content.content"></div>
            </article>

          </div>
        </div>
      </template>
      <template v-slot:footer></template>
    </modal>

    </div>

  </main>
</template>

<script>

import {PdfApi} from "@/api/pdf";
import {LinkApi, ProjectApi} from "@/api/project";
import SimLinks from "@/components/SimLinks.vue";
import RussianName from "@/plugins/morph";

export default {
  name: 'PdfDBDetail',
  components: {SimLinks},
  data() {
    return {
      links: [],
      project: null,
      pdf: null,
      content: null,
    }
  },
  mounted: function () {
    const $this = this;
    ProjectApi.get_simple(this.$route.params.id).then(response => {
      $this.project = response
    });
    if (this.$route.params.pdf_id) PdfApi.get(this.$route.params.pdf_id).then(response => {
      $this.pdf = response
    });
    PdfApi.links(this.$route.params.pdf_source, this.$route.params.id, this.$route.params.pdf_date).then(response => {
      $this.links = response
    });

  },
  computed: {
    tones: function () {
      let vm = this;
      return function (link) {
        return vm.$getTones(link.type_tone);
      };
    },
    type_tones: function () {
      let vm = this;
      return function (link) {
        return vm.$getTypes(link.tone);
      };
    },
  },
  methods: {
    getContent: function (id, link) {
      let $this = this;
      $this.active_link = link;
      LinkApi.get_content(id).then(response => {
        let content = response;
        $this.person_names = [];
        if (content.person_name) {
          let name = new RussianName(content.person_name);
          name.cases.forEach((_case) => {
            $this.person_names = $this.person_names.concat(name.fullName(_case).split(" "))
          });
        }
        let text = "", prev = 0, last_index = content.content.length + 1;
        content.negative_index.forEach((elem) => {
          let start = elem[0], end = elem[1];
          if ((start - prev) >= 1) text += content.content.substring(prev, start)
          text += `<span class="bg-negative">${content.content.substring(start, end)}</span>`
          prev = end;
        })
        if (prev < last_index) text += content.content.substring(prev, last_index);
        text = text.split('\n')
        text = text.map(x => `<p>${x}</p>`)
        content.content = text.join("");

        $this.content = content;
        $this.$modal('show', 'link_content');
      })
    },
    updateLink: function (link, update_field = [], update = false) {
      let $this = this, id = link.link_obj_id ? link.link_obj_id : link.id, data = {};
      if (update_field.length) {
        update_field.forEach(field => data[field] = link[field])
      } else data = JSON.parse(JSON.stringify(link))

      let link_index = $this.links.findIndex(x => x.id === link.id);
      data.id = id
      LinkApi.update(data, $this.$route.params.id).then(response => {
        if (update && link_index >= 0) $this.links.splice(link_index, 1, response)
        this.$notify({
          type: 'success ',
          text: 'Данные обновлены'
        });
      })
    },
    updateTypeTone(link, name, key) {
      if (key === 'our_derivative') {
        link.open_bind = true;
      } else {
        link.get_type_tone_display = name;
        link.type_tone = key;
        this.updateLink(link, ['type_tone'])
      }
    },

  }
}

</script>

<style scoped lang="scss">

</style>
